import { PayHeader } from "../Paymentheader/PayHeader";
import "./credit.css";
import { Button, Card, Result, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { useState, useEffect } from "react";
import {
  KYC_Status,
  Policy_PDF,
  Payment_Request,
} from "../../Redux/actions/NumBikeation";
import { KYC_Status_car } from "../../Redux/actions/NumCaration";
import axiosInCar from "../../Redux/axios/AxiosInCar";
export const Credit = () => {
  const dispatch = useDispatch();
  let PolicyDwnld = useSelector(
    (state) => state?.vehicledetail?.createProposal?.data
  );
  let KYCData = useSelector((state) => state?.vehicledetail?.KycStatus?.data);
  let PolicyDwnldCr = useSelector(
    (state) => state?.cardetail?.createProposal?.data
  );
  const bikeNum = useSelector((state) => state?.vehicledetail?.bikenum);
  const carNum = useSelector((state) => state?.cardetail?.carnum);
  let KYCDataCr = useSelector((state) => state?.cardetail?.KycStatus?.data);
  const Route = useSelector((state) => state?.common?.route);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  const proposal = useSelector(
    (state) => state?.vehicledetail?.createProposal?.data
  );
  const Carproposal = useSelector(
    (state) => state?.cardetail?.createProposal?.data
  );
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  // console.log(Route)
  console.log(KYCDataCr);
  const RouteAp =
    Route === "digit/bike_insurance"
      ? "bike_insurances"
      : Route === "digit/car_insurance"
      ? "car_insurances"
      : null;
  //  console.log(RouteAp)

  const handleKYC = () => {
    setLoading(true);
    let post = {
      policyNumber: PolicyDwnld?.policyNumber,
    };
    axiosInstance
      .post(
        `v2/${RouteAp}/${bikeNum?.bike_insurance_id}/insurers/${SelectedQQ?.provider}/kyc_status`,
        post
      )
      .then((res) => {
        let data = res?.data;
        dispatch(KYC_Status(data));
        if (data?.data?.link) {
          window.open(data.data.link, "_blank");
        }
        setLoading(false);
      })
      .catch((err) => {
        message.error(err?.response?.data?.error);
        setLoading(false);
      });
  };
  const handleKYCCar = () => {
    setLoading(true);
    let post = {
      policyNumber: PolicyDwnldCr?.policyNumber,
    };
    axiosInCar
      .post(
        `v2/${RouteAp}/${carNum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/kyc_status`,
        post
      )
      .then((res) => {
        // console.log(res)
        let data = res?.data;
        dispatch(KYC_Status_car(data));
        // console.log(data.data.link)
        if (data.data.link) {
          window.open(data.data.link, "_blank");
        }
        setLoading(false);
      })
      .catch((err) => {
        // console.log(err.response)
        message.error(err.response.data.error);
        setLoading(false);
      });
  };
  const HnadlePayment = () => {
    let post = {
      insurance_id: bikeNum?.bike_insurance_id,
      applicationId: proposal?.applicationId,
    };
    axiosInstance
      .post(
        `v2/bike_insurances/${bikeNum?.bike_insurance_id}/insurers/${SelectedQQ?.provider}/payment_request`,
        post
      )
      .then((res) => {
        console.log("Final Proposal", res);
        // setIsLoading(false);
        if (res.status === 200) {
          if (SelectedQQ?.provider === "go_digit") {
            // dispatch(SelectedRoute("digit/bike_insurance"));
            // history.push("/credit");
            let Paydata = {
              data: res.data.data,
              post: post,
            };
            // console.log(Paydata);
            // console.log(Paydata?.data?.dispatcherResponse);
            window.open(Paydata?.data?.dispatcherResponse, "_blank");
            // dispatch(Payment_Request(Paydata));
          }
        }
      });
  };
  const HnadlePaymentCar = () => {
    let post = {
      insurance_id: carNum?.car_insurance_id,
      applicationId: Carproposal?.applicationId,
    };
    axiosInCar
      .post(
        `v2/bike_insurances/${carNum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/payment_request`,
        post
      )
      .then((res) => {
        console.log("Final Proposal", res);
        // setIsLoading(false);
        if (res.status === 200) {
          if (SelectedQQ?.provider === "go_digit") {
            // dispatch(SelectedRoute("digit/bike_insurance"));
            // history.push("/credit");
            let Paydata = {
              data: res.data.data,
              post: post,
            };
            // console.log(Paydata);
            // console.log(Paydata?.data?.dispatcherResponse);
            window.open(Paydata?.data?.dispatcherResponse, "_blank");
            dispatch(Payment_Request(Paydata));
          }
        }
      });
  };
  const handleButton = () => {
    setLoading(true);
    let post = {
      policyId: PolicyDwnld?.applicationId,
    };
    // v2/bike_insurances/{insurance}/insurers/{insurer}/pdf_generation
    axiosInstance
      .post(
        `v2/${RouteAp}/${bikeNum?.bike_insurance_id}/insurers/${SelectedQQ?.provider}/pdf_generation`,
        post
      )
      .then((res) => {
        // console.log(res)
        let data = res?.data;
        // console.log(data.data.schedulePath)
        if (data?.data?.schedulePath) {
          window.open(data.data.schedulePath, "_blank");
        }
        dispatch(Policy_PDF(data));
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response.data.error);
        message.error(err.response.data.error.errorMessage);
        setLoading(false);
      });
  };
  const handleButtonCar = () => {
    setLoading(true);
    let post = {
      policyId: PolicyDwnldCr?.applicationId,
    };
    axiosInCar
      .post(
        `v2/${RouteAp}/${carNum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/pdf_generation`,
        post
      )
      .then((res) => {
        // console.log(res)
        let data = res.data;
        // console.log(data.data.schedulePath)
        if (data?.data?.schedulePath) {
          window.open(data.data.schedulePath, "_blank");
        }
        dispatch(Policy_PDF(data));
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response.data.error);
        message.error(err.response.data.error.errorMessage);
        setLoading(false);
      });
  };
  return (
    <>
      <PayHeader />
      {Route === "digit/bike_insurance" ? (
        <>
          <div className="row justify-content-center py-3">
            {KYCData?.kycVerificationStatus === "DONE" ? (
              <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
                <Result
                  status="success"
                  title="You have successfully Verified KYC"
                  subTitle={
                    <>
                      <p>Quote No: ${PolicyDwnld?.policyNumber}</p>
                      {KYCData?.paymentStatus === "NOT_PAID" && (
                        <p style={{ color: "red" }}>Payment Pending</p>
                      )}
                    </>
                  }
                  extra={[
                    KYCData?.paymentStatus === "NOT_PAID" ? (
                      <Button
                        loading={loading}
                        onClick={HnadlePayment}
                        type="primary"
                        key="get-payment-link"
                      >
                        Get Payment Link
                      </Button>
                    ) : (
                      <Button
                        loading={loading}
                        onClick={handleButton}
                        type="primary"
                        key="download-policy"
                      >
                        Download Policy
                      </Button>
                    ),
                  ]}
                />
              </Card>
            ) : (
              <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
                <Result
                  status="warning"
                  title="Verify Your KYC Satus"
                  subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
                  extra={[
                    <Button
                      loading={loading}
                      onClick={handleKYC}
                      type="primary"
                      key="console"
                    >
                      Click to Verify KYC Status
                    </Button>,
                  ]}
                />
              </Card>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="row justify-content-center py-3">
            {KYCDataCr?.kycVerificationStatus === "DONE" ? (
              <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
                <Result
                  status="success"
                  title="You have successfully Verified KYC"
                  subTitle={
                    <>
                      <p>Quote No: ${Carproposal?.policyNumber}</p>
                      {KYCDataCr?.paymentStatus === "NOT_PAID" && (
                        <p style={{ color: "red" }}>Payment Pending</p>
                      )}
                    </>
                  }
                  extra={[
                    // KYCDataCr?.paymentStatus === "NOT_PAID" ? (
                    //   <Button
                    //     loading={loading}
                    //     onClick={HnadlePaymentCar}
                    //     type="primary"
                    //     key="get-payment-link"
                    //   >
                    //     Get Payment Link
                    //   </Button>
                    // ) : (
                    <Button
                      loading={loading}
                      onClick={handleButtonCar}
                      type="primary"
                      key="download-policy"
                    >
                      Download Policy
                    </Button>,
                    // ),
                  ]}
                  // extra={[
                  //   <Button
                  //     loading={loading}
                  //     onClick={handleButtonCar}
                  //     type="primary"
                  //     key="console"
                  //   >
                  //     Download Policy
                  //   </Button>,
                  // ]}
                />
              </Card>
            ) : (
              <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
                <Result
                  status="warning"
                  title="Verify Your KYC Satus"
                  subTitle={`Quote No: ${Carproposal?.policyNumber}`}
                  extra={[
                    <Button
                      loading={loading}
                      onClick={handleKYCCar}
                      type="primary"
                      key="console"
                    >
                      Click to Verify KYC Status
                    </Button>,
                  ]}
                />
              </Card>
            )}
          </div>
        </>
      )}

      <div className="footter-md-cnfrm">
        <div className="footter-md-1">
          <p>
            Registration No. 742, Registration Code No. IRDA/ DB 797/ 19, Valid
            till 09/06/2024, License category- Direct Broker (Life & General)
          </p>
          <p> solely based on the information received from the insurers.</p>
        </div>
        <div className="footer-md-2">
          <p>@Copyright 2018-2024</p>
          <p>
            <a href="www.VIBE.com">VIBE</a>
          </p>
          <p>All rights reserved</p>
        </div>
      </div>
    </>
  );
};
